// src/Routes/Prompts/CreatePrompt.tsx
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleAnalyticsContext } from "../../Hooks/GoogleAnalyticsContext";
import PromptEditor from "../../Components/HighLevelComponents/UserPromptManagement/components/PrompEditor.tsx/PromptEditor";
import SidebarLayout from "../../Components/Layout/SidebarLayout";
import ChatToolCreator from "../../Components/HighLevelComponents/ChatToolCreator/ChatToolCreator";

type CreationMode = "manual" | "chat";

const CreatePrompt: React.FC = () => {
  const navigate = useNavigate();
  const { logEvent } = useContext(GoogleAnalyticsContext);
  const [mode, setMode] = useState<CreationMode>("chat");

  useEffect(() => {
    logEvent("CustomToolAction", `CreateToolView_${mode}`);
  }, [mode]);

  const handleModeSwitch = (newMode: CreationMode) => {
    setMode(newMode);
    logEvent(
      "CustomToolAction",
      `SwitchTo${newMode.charAt(0).toUpperCase() + newMode.slice(1)}Mode`
    );
  };

  const handleCancel = () => {
    logEvent("CustomToolAction", `CancelCreation_${mode}`);
    navigate("/custom-tools");
  };

  const handleSave = () => {
    logEvent("CustomToolAction", `SaveCreation_${mode}`);
    navigate("/custom-tools");
  };

  return (
    <SidebarLayout>
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              Create Your Custom Tool
            </h1>
            <p className="text-gray-600 mt-1">
              Choose how you'd like to create your tool:
            </p>
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => handleModeSwitch("manual")}
              className={`px-4 py-2 rounded-md ${
                mode === "manual"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              Build Manually
            </button>
            <button
              onClick={() => handleModeSwitch("chat")}
              className={`px-4 py-2 rounded-md ${
                mode === "chat"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              Chat with Yip
            </button>
          </div>
        </div>

        {mode === "manual" ? (
          <PromptEditor
            selectedPrompt={null}
            onCancel={handleCancel}
            onSave={handleSave}
          />
        ) : (
          <ChatToolCreator />
        )}
      </div>
    </SidebarLayout>
  );
};

export default CreatePrompt;
